<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          large
          icon
          class="full-button"
          elevation="0"
          :class="{ 'button-gradient': !loading }"
          :disabled="loading"
          :height="buttonHeight"
          :width="buttonHeight"
          v-bind="attrs"
          v-on="on"
          @click="copyLink"
          id="share-link"
        >
          <v-icon>mdi-link-variant</v-icon>
        </v-btn>
      </template>
      <span>{{ $i18n.t("selectors.share.copy") }}</span>
    </v-tooltip>
    <v-snackbar v-model="snackbar" top color="primary" :timeout="timeout">{{ $i18n.t("notifications.copy") }}</v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ShareLink",
  data() {
    return {
      snackbar: false,
      timeout: 3000,
    };
  },
  props: {
    loading: Boolean,
    buttonHeight: {
      type: String,
      default: "50px",
    },
  },
  methods: {
    fallbackCopyTextToClipboard(value) {
      const textArea = document.createElement("textarea");
      textArea.value = value;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    },
    copyTextToClipboard(value) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(value);
        return;
      }
      navigator.clipboard.writeText(value);
    },
    copyLink() {
      const funds = this.$store.state.selectedFunds
        // eslint-disable-next-line arrow-parens
        .map(fund => `${fund.category}_${fund.fundId}_${fund.series}`)
        .join(",");
      // eslint-disable-next-line max-len
      const output = `${window.location.origin}/?funds=${funds}&startDate=${this.$store.state.selectedDate.startDate}&endDate=${this.$store.state.selectedDate.endDate}&currency=${this.$store.state.selectedCurrency}`;
      this.copyTextToClipboard(output);
      this.snackbar = true;
    },
  },
};
</script>

<style scoped></style>
